import React from 'react';
import { Helmet } from 'react-helmet-async';
interface SEOProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
  twitterCard?: string;
}
const SEO = ({
  title,
  description,
  canonicalUrl,
  keywords = 'SmartSoda, office beverages, sustainable drinks, premium beverages, beverage dispenser',
  ogImage = 'https://uploadthingy.s3.us-west-1.amazonaws.com/398zF3f9vnPCBcDJKMBLw8/HeroSmartSoda.png',
  ogType = 'website',
  twitterCard = 'summary_large_image'
}: SEOProps) => {
  // Ensure title is not too long (Google typically displays first 50-60 characters)
  const metaTitle = title.length > 60 ? `${title.substring(0, 57)}...` : title;
  // Ensure description is not too long (Google typically displays ~155-160 characters)
  const metaDescription = description.length > 160 ? `${description.substring(0, 157)}...` : description;
  return <Helmet data-id="element-2382" data-mp="305t0d4rp7lg5">
      {/* Basic Meta Tags */}
      <title data-id="element-2383" data-mp="29ihcpgnrjzzu">{metaTitle}</title>
      <meta name="description" content={metaDescription} data-id="element-2384" data-mp="29hfxczzpsrcb" />
      <meta name="keywords" content={keywords} data-id="element-2385" data-mp="24jef2ha44w1w" />
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} data-id="element-2386" data-mp="24hjvb6akv9ze" />}
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} data-id="element-2387" data-mp="1zme7g1xm7l8o" />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} data-id="element-2388" data-mp="1ukf3apu1wkao" />}
      <meta property="og:title" content={metaTitle} data-id="element-2389" data-mp="1qjd2w5oee274" />
      <meta property="og:description" content={metaDescription} data-id="element-2390" data-mp="1ql69jkz0gmf4" />
      <meta property="og:image" content={ogImage} data-id="element-2391" data-mp="1lsmxisfz1zcf" />
      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} data-id="element-2392" data-mp="1gttl73cf8edu" />
      <meta name="twitter:title" content={metaTitle} data-id="element-2393" data-mp="1gubmwfhurkt5" />
      <meta name="twitter:description" content={metaDescription} data-id="element-2394" data-mp="1bv8ubuj27722" />
      <meta name="twitter:image" content={ogImage} data-id="element-2395" data-mp="1bsme76i3rj88" />
      {/* Additional Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" data-id="element-2396" data-mp="16uuie1ec7cyr" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" data-id="element-2397" data-mp="12vbz1a25z9y1" />
      <meta name="robots" content="index, follow" data-id="element-2398" data-mp="s8nrlvnxp6h6" />
    </Helmet>;
};
export default SEO;